import React, { useCallback, useEffect, useState } from "react";
import router from "next/router";
import { Button } from "components/atoms/Button";
import { ButtonType } from "components/atoms/Button/types";
import CompetitionList from "components/atoms/CompetitionList";
import { Modal } from "components/atoms/Modal";
import { getEligibleCompetitions } from "lib/actions";
import { CompetitionDTO } from "types";
import { Span, SubTitle, Text } from "utils/styling/typography.styled";
import * as Styled from "./EligibleCompetitionsModal.styled";
interface EligibleCompetitionsModalProps {
  isOpen: boolean;
  onCancel: () => void;
  imageId: string | null;
}
const EligibleCompetitionsModal: React.FC<EligibleCompetitionsModalProps> = ({
  isOpen,
  onCancel,
  imageId
}) => {
  const [competitions, setCompetitions] = useState<CompetitionDTO[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  useEffect(() => {
    if (isOpen && imageId) {
      setLoading(true);
      getEligibleCompetitions(imageId).then(response => {
        setCompetitions(response.competition || []);
        setLoading(false);
      }).catch(() => {
        setError("Failed to fetch eligible competitions");
        setLoading(false);
      });
    }
  }, [isOpen, imageId]);
  const handleCompetitionClick = useCallback((compId: string) => {
    onCancel();
    router.push(`/competitions/${compId}?image=${imageId}`);
  }, [onCancel, imageId]);
  return <Modal open={isOpen} handleBackdropClick={onCancel} data-sentry-element="Modal" data-sentry-component="EligibleCompetitionsModal" data-sentry-source-file="index.tsx">
            <Styled.ModalContainer data-sentry-element="unknown" data-sentry-source-file="index.tsx">
                <SubTitle data-sentry-element="SubTitle" data-sentry-source-file="index.tsx">Eligible Competitions</SubTitle>
                <hr />
                {loading && <Text>Loading...</Text>}
                {!loading && !error && competitions.length === 0 && <Text>No eligible competitions found.</Text>}
                {!loading && !error && competitions.length > 0 && <CompetitionList competitions={competitions} onCompetitionClick={handleCompetitionClick} />}
                <Styled.Container data-sentry-element="unknown" data-sentry-source-file="index.tsx">
                    <Button type="button" variant={ButtonType.PRIMARY} onClick={onCancel} data-sentry-element="Button" data-sentry-source-file="index.tsx">
                        <Span data-sentry-element="Span" data-sentry-source-file="index.tsx">Cancel</Span>
                    </Button>
                </Styled.Container>
            </Styled.ModalContainer>
        </Modal>;
};
export default EligibleCompetitionsModal;